import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-mobile-config.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-mobile-config.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AlertType } from "../../../../shared/models/alert";
import { HttpClient } from "@angular/common/http";
import { AppControllerService } from "../../../../app-controller.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CreateMobileConfigConstants } from "./create-mobile-config.constants";
import { LogValidatorErrors } from "../../../organisation-config/shared/log-validator-errors";
import { ValidationMessage, FormError } from "./create-mobile-config.constants";
import { ApiMobileConfigConstants } from "../../../../shared/constants/api-constants/api-mobileConfig.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { AppConfig } from "../../../../app.config";
let CreateMobileConfigComponent = class CreateMobileConfigComponent {
    activeModal;
    http;
    appController;
    modalTitle;
    existingMobileConfigs;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    createMobileConfigForm;
    formErrors = FormError;
    logValidatorErrors = LogValidatorErrors;
    validationMessage = ValidationMessage;
    minAppVersionFormControl = CreateMobileConfigConstants.MIN_APP_VERSION_FORM_CONTROL;
    minAppVersionTextPlaceHolder = CreateMobileConfigConstants.MIN_APP_VERSION_TEXT_PLACEHOLDER;
    maxOfflineHoursFormControl = CreateMobileConfigConstants.MAX_OFFLINE_HOURS_FORM_CONTROL;
    maxOfflineHoursTextPlaceHolder = CreateMobileConfigConstants.MAX_OFFLINE_HOURS_TEXT_PLACEHOLDER;
    allowOfflineAccessFormControl = CreateMobileConfigConstants.ALLOW_OFFLINE_ACCESS_FORM_CONTROL;
    allowOfflineAccessTextPlaceHolder = CreateMobileConfigConstants.ALLOW_OFFLINE_ACCESS_TEXT_PLACEHOLDER;
    errorObjectName = CreateMobileConfigConstants.ERROR_OBJECT_NAME;
    formData;
    mobileConfigValue;
    saveSuccessMessage = SharedConstants.ADD_SUCCESS;
    invalidFields = SharedConstants.FORM_NOT_VALID;
    mobileConfigUrl = ApiMobileConfigConstants.URL;
    cancelLabel = CreateMobileConfigConstants.CANCEL_BUTTON_LABEL;
    createLabel = CreateMobileConfigConstants.ADD_BUTTON_LABEL;
    IMobileConfigSubscription;
    constructor(activeModal, http, appController) {
        this.activeModal = activeModal;
        this.http = http;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
        this.initForm();
    }
    ngOnInit() {
    }
    initForm() {
        this.createMobileConfigForm = new FormGroup({
            minAppVersion: new FormControl("1.0.0", [
                Validators.required,
                Validators.pattern(RegExp(/\d{1,3}\.\d{1,3}\.?\d{1,3}?/g)),
                Validators.maxLength(12),
            ]),
            maxOfflineHours: new FormControl(24, [
                Validators.required,
                Validators.pattern(RegExp(/[0-9]{1,2}$/)),
                Validators.maxLength(2),
            ]),
            allowOfflineAccess: new FormControl(false, [
                Validators.required,
                Validators.maxLength(5),
            ]),
        });
    }
    allowOfflineAccessChecked(event) {
        const checkBoxStatus = event.target.checked;
        this.createMobileConfigForm.get(this.allowOfflineAccessFormControl).setValue(checkBoxStatus);
    }
    createMobileConfig() {
        if (this.createMobileConfigForm.invalid) {
            this.appController.showMessage(this.invalidFields, AlertType.Warning);
            return;
        }
        this.mobileConfigValue = { ...this.createMobileConfigForm.value };
        this.IMobileConfigSubscription =
            this.http.post(this.mobileConfigUrl, this.mobileConfigValue)
                .subscribe((mob) => {
                if (!this.formData) {
                    this.appController.showMessage(this.saveSuccessMessage, AlertType.Success);
                    this.activeModal.close(true);
                }
            });
        (error) => {
            this.appController.handleServerErrorMessage(this.errorObjectName, error, CRUDOperation.Add);
        };
    }
    onBtnSaveClicked() {
        this.createMobileConfig();
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: HttpClient },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        existingMobileConfigs: [{ type: Input }]
    };
};
CreateMobileConfigComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-mobile-config",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateMobileConfigComponent);
export { CreateMobileConfigComponent };
